import React from "react";
import { Portal, useDialog } from "./Sheet";

// Centred dialog in the app's style (app/components/CustomModal.js).
const AppModal = ({ open, onClose, title, children, actions, className = "" }) => {
  const ref = useDialog(open, onClose);
  if (!open) return null;

  return (
    <Portal>
      <div className="hx-modal-backdrop" onClick={onClose}>
        <div
          ref={ref}
          className={`hx-modal ${className}`}
          role="dialog"
          aria-modal="true"
          aria-label={title}
          tabIndex={-1}
          onClick={(event) => event.stopPropagation()}
        >
          {title ? <h2 className="hx-modal-title">{title}</h2> : null}
          {children}
          {actions ? <div className="hx-modal-actions">{actions}</div> : null}
        </div>
      </div>
    </Portal>
  );
};

export default AppModal;
